import type { Checklist, UpdatedChecklist } from '@cobliteam/api-lib';
import type { FormValues } from './checklistSchema';

export const CHECKLIST_VERSION = 2;

const formValuesToChecklist = (formChecklist: FormValues, newChecklist: boolean): UpdatedChecklist => {
  return {
    name: formChecklist.name,
    version: CHECKLIST_VERSION,
    ...(newChecklist ? {} : { template_active: formChecklist.active }), //template_active is only used when updating a checklist
    vehicleIds: formChecklist.vehicleIds ?? [],
    vehicleGroupIds: formChecklist.vehicleGroupIds ?? [],
    fields: formChecklist.items.map((item) => ({
      type: item.type,
      title: item.title,
      required: item.required,
      shouldRequestPhotos: item.shouldRequestPhotos ?? false,
      content: {
        value: item.content.value,
        checked: item.content.checked,
        label: item.content.label,
        options: item.content.options?.map((option) => ({
          label: option.label,
          checked: false,
        })),
      },
    })),
  };
};

const checklistToFormValues = (checklist?: Checklist): FormValues => {
  return {
    name: checklist?.name ?? '',
    active: checklist?.templateActive ?? true,
    vehicleIds: checklist?.vehicleIds ?? [],
    vehicleGroupIds: checklist?.vehicleGroupIds ?? [],
    items:
      checklist?.fields.map((field) => ({
        title: field.title,
        type: field.type,
        required: field.required,
        shouldRequestPhotos: field.shouldRequestPhotos,
        content: {
          value: 'value' in field.content ? field.content.value : null,
          checked: 'checked' in field.content ? field.content.checked : null,
          label: 'label' in field.content ? (field.content.label as string) : null,
          options: 'options' in field.content ? field.content.options.map((option) => ({ label: option.label })) : null,
        },
      })) ?? [],
  };
};

export { formValuesToChecklist, checklistToFormValues };
